import { g as getLocale, t as trackMessageCall } from "./runtime.js";
const en_invalid_email_not_allowed = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Login is restricted to specific e-mail addresses or domains`;
  }
);
const de_invalid_email_not_allowed = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Der Zugang ist auf bestimmte E-Mail-Adressen oder Domänen beschränkt`;
  }
);
const sp_invalid_email_not_allowed = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `El acceso está restringido a direcciones de correo electrónico o dominios específicos`;
  }
);
const invalid_email_not_allowed = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("invalid_email_not_allowed", locale);
  if (locale === "en") return en_invalid_email_not_allowed();
  if (locale === "de") return de_invalid_email_not_allowed();
  return sp_invalid_email_not_allowed();
};
export {
  invalid_email_not_allowed as i
};
